import { useAppDispatch, useAppSelector } from "@/lib/redux/store";

export const useToasts = () =>
{
    const dispatch = useAppDispatch();
    const store = useAppSelector((state) => state.app || {});
    const toasts = Array.isArray(store.toasts) ? store.toasts : [];

    const addToast = (variant, message) =>
    {
        if (!variant || !message)
        {
            throw new Error('Toast variant and message are required');

        }
        if (typeof variant !== 'string' || typeof message !== 'string')
        {
            throw new Error('Toast variant and message must be strings');
        }
        // Ensure variant is one of the allowed types
        const allowedVariants = [
            'primary',
            'secondary',
            'success',
            'danger',
            'warning',
            'info',
            'light',
            'dark',
        ];
        if (!allowedVariants.includes(variant))
        {
            throw new Error(`Invalid toast variant: ${variant}. Allowed variants are: ${allowedVariants.join(', ')}`);
        }
        if (typeof window !== 'undefined')
        {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        // Generate a unique ID for the toast
        const id = Date.now() + Math.random().toString(36).substring(2, 9);
        // Create the toast object
        const toast = { id, variant, message };
        dispatch({ type: 'app/addToast', payload: toast });
    };

    const removeToast = (() =>
    {
        let timeout;
        return (id) =>
        {
            clearTimeout(timeout);
            timeout = setTimeout(() =>
            {
                dispatch({ type: 'app/removeToast', payload: id });
            }, 500); // Adjust debounce time as needed
        };
    })();

    return {
        toasts,
        addToast,
        removeToast,
    };
}